/* PULL UP — Theme JS
   Handles: newsletter post-submit scroll, cart add, toasts.
   Newsletter uses the native Shopify customer form (double opt-in). The 50% code (LOUDLIST)
   is delivered by the welcome email after confirmation; Shopify validates it at checkout
   (only confirmed email subscribers, once per customer). */

(function(){
  // Legacy cleanup from older theme versions
  try { localStorage.removeItem('pullup_subscribed'); } catch(e){}
  document.body.classList.remove('discount-mode');

  // After the newsletter form posts, Shopify reloads with ?customer_posted=true — bring the card into view
  if (/[?&]customer_posted=true/.test(location.search)) {
    var card = document.getElementById('subscribe-card');
    if (card) setTimeout(function(){ card.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 250);
  }

  // Toast
  let toastEl = null, toastTimer = null;
  function ensureToast(){
    if(toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'toast';
    toastEl.innerHTML = '<span class="icon">✓</span><span class="msg"></span>';
    document.body.appendChild(toastEl);
    return toastEl;
  }
  function showToast(msg){
    const t = ensureToast();
    t.querySelector('.msg').textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(()=>t.classList.remove('show'), 3500);
  }
  window.PullUp = window.PullUp || {};
  window.PullUp.showToast = showToast;

  // Cart count badge — refresh from Shopify cart
  function refreshCartCount(){
    fetch('/cart.js', { headers: { 'Accept':'application/json' }})
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-badge').forEach(el => {
          el.textContent = cart.item_count || 0;
        });
      })
      .catch(()=>{});
  }
  refreshCartCount();
  window.PullUp.refreshCartCount = refreshCartCount;

  // Add to cart via AJAX
  window.PullUp.addToCart = function(variantId, quantity, onSuccess){
    const data = { items: [{ id: variantId, quantity: quantity || 1 }] };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(r => r.json())
    .then(result => {
      if(result.status && result.status >= 400){
        showToast('✗ ' + (result.description || 'Eroare la adăugarea în coș'));
        return;
      }
      refreshCartCount();
      if(onSuccess) onSuccess(result);
      showToast('✓ Adăugat în coș');
    })
    .catch(() => showToast('✗ Eroare de rețea'));
  };

  // Remove from cart
  window.PullUp.removeFromCart = function(lineKey, onSuccess){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
    .then(r => r.json())
    .then(cart => {
      refreshCartCount();
      if(onSuccess) onSuccess(cart);
    })
    .catch(()=>{});
  };

  // Update quantity
  window.PullUp.updateQuantity = function(lineKey, qty, onSuccess){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => {
      refreshCartCount();
      if(onSuccess) onSuccess(cart);
    })
    .catch(()=>{});
  };

})();
